<template>
  <div class="invoice-period-table">
    <h3>{{ title }}</h3>
    <table class="table" v-if="lines && lines.length > 0">
      <thead>
        <tr>
          <th>Omschrijving</th>
          <th class="text-right">Stuksprijs</th>
          <th v-if="showBTW" class="text-right">BTW</th>
          <th v-if="showAmount" class="text-right">Aantal</th>
          <th class="text-right">Totaal</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(line, index) in lines" :key="index">
          <td>{{ line.name }}</td>
          <td class="text-right">€ {{ formatPrice(line.price || 0) }}</td>
          <td v-if="showBTW" class="text-right">{{ line.btw || 0 }}%</td>
          <td v-if="showAmount" class="text-right">{{ line.amount || 0 }}</td>
          <td class="text-right">€ {{ formatPrice(line.total || 0) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td :colspan="colspan"></td>
          <td class="text-right"><strong>€ {{ formatPrice(total || 0) }}</strong></td>
        </tr>
      </tfoot>
    </table>
    <div v-else class="no-lines">
      Geen regels beschikbaar voor deze factuur.
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoicePeriodTable',

  props: {
    title: {
      type: String,
      required: true
    },
    lines: {
      type: Array,
      required: true
    },
    showBTW: {
      type: Boolean,
      default: true
    },
    showAmount: {
      type: Boolean,
      default: true
    },
    isDeposit: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    colspan() {
      let count = 1; // Description column
      if (this.showBTW) count++;
      if (this.showAmount) count++;
      count++; // Price column
      return count;
    },

    total() {
      return (this.lines || []).reduce((sum, line) => sum + (line.total || 0), 0)
    }
  },

  methods: {
    formatPrice(value) {
      return Number(value || 0).toFixed(2)
    }
  }
}
</script>

<style scoped>
.invoice-period-table {
  width: 100%;
  margin-bottom: 2rem;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 0.75rem;
  border-bottom: 1px solid #dee2e6;
}

.table th {
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.text-right {
  text-align: right;
}

tfoot tr td {
  border-top: 2px solid #dee2e6;
  font-weight: bold;
}

.no-lines {
  padding: 1rem;
  text-align: center;
  color: #666;
}
</style>